import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { apiErrorMessage } from "../../helper/apiError";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import Linkify from 'react-linkify';  
import {
  Badge,
  Box,
  Button as MuiButton,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormGroup,
  Grid,
  Icon,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../component/button/button";
import OutlineCustomButton from "../../component/button/outlineButton";
import {
  GetFilteredUserAction,
  GetOrganizationAction,
  GetRoleAction,
  GetUserAction,
  GetUserChatAction,
  GetUserChatByIdAction,
  MarkedChatAsPinned,
  MarkedChatAsUnread,
} from "../../Redux/action/SettingAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Msg from "../../Icon/Msg";
import { type } from "@testing-library/user-event/dist/type";
import {
  AddtochatService,
  DeleteChatForMeService,
  DeleteMsgFromChatService,
  EditMsgToChatService,
  LeaveChatService,
  RenameGroupChatService,
} from "../../Redux/service/SettingService";
import moment from "moment/moment";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import AttachmentDropzone from "../../component/dropzone/AttachmentDropzone";
import {
  AddCircleTwoTone,
  Delete,
  DeleteForeverOutlined,
  DeleteForeverRounded,
  MarkAsUnread,
  RemoveCircleOutline,
  Chat,
  Pin,
  Group,
  DeleteOutline,
} from "@mui/icons-material";
import PushPinSharpIcon from "@mui/icons-material/PushPinSharp";
import "../chat/chatlistpage.css";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import SendIcon from "@mui/icons-material/Send";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { CreateChatModal } from "../../component/ChatSectionModal/CreateChat.component";
import { ChatListNav } from "../../component/ChatSectionModal/ChatListSideNav.component";
import { ReceiverSection } from "../../component/ChatSectionModal/ReceiverSection.component";
import { CreateGroupChatModal } from "../../component/ChatSectionModal/AddGroupPersonChatModal.component";
import { AddPersonToChatChatModal } from "../../component/ChatSectionModal/AddPersonToChat";
import Crossicon from "../../Icon/Crossicon";
import {
  DownCircleFilled,
  DownCircleOutlined,
  EyeFilled,
} from "@ant-design/icons";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import FilePreviewer from "./testingpreview";
import { RemovePersonToChatChatModal } from "../../component/ChatSectionModal/RemovePersonToChat";
import axios from "axios";
import { basicurl } from "../../Redux/ServiceUrl/url";
import {
  markSeenMessagesAPI,
  postmarkSeenMessagesAPI,
} from "../../Redux/service/notificationService";
import { Button } from "antd";
import { Dropdown } from "@mui/base";
import { Select } from "@material-ui/core";
import DownloadIcon from '@mui/icons-material/Download';
import OutlinedTextAreaField from "../../component/inputfiled/OutlinedTextedArea";
import useChatSocket from "../../socket/useChatSocket";
import {
  buildChatList,
  isChatPinnedFor,
  resolveMyId,
} from "./chatListOrder";
import { MESSAGE_STATUS } from "../../socket/events";
import MessageTicks from "../../component/ChatSectionModal/MessageTicks.component";
import {
  OnlineDot,
  PresenceLabel,
  TypingIndicator,
} from "../../component/ChatSectionModal/PresenceIndicator.component";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { sm: "100%", xs: "100%", md: "50%", lg: "50%" },
  height: "60vh",
  overflow: "scroll",
  bgcolor: "background.paper",
  border: "2px solid grey",
  boxShadow: 24,
  p: 4,
};

const drawerWidth = 240;

const ChatlistPage = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const childRef = useRef();

  const [selectedMsgId, setSelectedMsgId] = useState(null);
  const [open, setOpen] = React.useState(false);

  const [Organizationlist, setOrganizationlist] = useState([]);

  const [Chatlist, setChatlist] = useState([]);

  const [table_load, setTable_load] = useState(false);

  const [ChatByIdlist, setChatByIdlist] = useState([]);

  const [formLoading, setFormLoading] = useState(false);

  const [chatId, setChatId] = useState("");

  const [Userlist, setUserlist] = useState([]);

  const [isOpen, setIsOpen] = useState(true);

  const [filteredUser, setFilteredUser] = useState([]);

  const [Rolelist, setRolelist] = useState([]);

  const [chatTextField, setChatTextField] = useState([]);

  const [ChatEditMsg, setChatEditMsg] = useState("");

  const [visibleIcons, setVisibleIcons] = useState({});

  const [chatModal, setChatModal] = useState(false);

  const [AddGroupChat, setAddGroupChat] = useState(false);

  const [AddPersonChat, setAddPersonChat] = useState(false);

  const [RemovePersonChat, setRemovePersonChat] = useState(false);

  const [AttachedFiles, setAttachedFiles] = useState();

  // Rename dialog for group chats (3+ participants)
  const [renameOpen, setRenameOpen] = useState(false);
  const [renameValue, setRenameValue] = useState("");

  // Chat overflow menu + "delete for me" / "leave chat" confirmation
  const [chatMenuAnchor, setChatMenuAnchor] = useState(null);
  // Row actions in the conversation list. One shared menu rather than one per
  // row, so the list stays cheap to render.
  const [listMenu, setListMenu] = useState({ anchor: null, chat: null });
  const [confirmAction, setConfirmAction] = useState(null); // "delete" | "leave"

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const [filterChat, setFilterChat] = React.useState("ALL");

  const handleChange = (event) => {
    setFilterChat(event.target.value);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = () => {
    dispatch(GetUserChatAction());

    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setTable_load(true);
    let data = {
      page: 1,
      limit: 0,
    };
    dispatch(GetOrganizationAction(data));
  }, []);

  useEffect(() => {
    let data = {
      firstName: null,
      lastName: null,
      roles: null,
      roleType: null,
      organization: null,
      email: null,
    };
    dispatch(GetFilteredUserAction(data));
    dispatch(GetUserChatAction());
  }, []);

  const validationSchema = Yup.object().shape({
    text: Yup.string()
      // .required("Resend date is required")/
      .when("url", {
        is: (url) => !url,
        then: (schema) =>
          schema.test(
            "is-greater",
            "Either text or file is required to send to chat",
            function (value) {
              const { url } = this.parent;

              if (url !== "" && !value) {
                console.log("no file");
                return false;
              }
              return true;
            }
          ),
        otherwise: (schema) => schema.notRequired(),
      }),
    url: Yup.string().notRequired(),
  });

  const OrganizationlistState = useSelector(
    (state) => state.setting?.organization?.data?.organizations
  );
  const FilteredUserlistState = useSelector(
    (state) => state.setting?.filteredUser?.data?.data
  );

  const ChatlistState = useSelector(
    (state) => state.setting?.allchat?.data?.data
  );

  // //(ChatlistState);

  useEffect(() => {
    const updatedData = FilteredUserlistState?.map(
      ({ firstName, ...rest }) => ({
        title: firstName,
        ...rest,
      })
    );
    setFilteredUser(updatedData);
  }, [FilteredUserlistState]);

  useEffect(() => {
    const updatedData = OrganizationlistState?.map(
      ({ organizationName, ...rest }) => ({
        title: organizationName,
        ...rest,
      })
    );
    setOrganizationlist(updatedData);
  }, [OrganizationlistState]);

  // useEffect(() => {
  //   setChatlist(ChatlistState);
  // }, [ChatlistState]);

  // =========================================================================
  // Realtime layer
  // =========================================================================
  const currentUserId = window.sessionStorage.getItem("user_id");
  const currentRoleType = window.sessionStorage.getItem("user_role_type");

  /**
   * Mirrors the server rule in ChatController.removeParticipantsFromChat: the
   * person who created the chat, or a platform admin, may remove members.
   * Anyone else only sees the "Add people" button - showing a control that is
   * guaranteed to fail is worse than not showing it.
   */
  const canRemoveParticipants = (chat) =>
    String(chat?.createdBy?._id || chat?.createdBy || "") ===
      String(currentUserId) || ["admin", "sub_admin"].includes(currentRoleType);
  const messagesEndRef = useRef(null);

  /** Inserts or merges a message into the conversation currently on screen. */
  const upsertMessage = useCallback((message) => {
    if (!message) return;

    setChatByIdlist((previous) => {
      if (!previous || String(previous._id) !== String(message.chatId)) {
        return previous;
      }

      const messages = [...(previous.messages || [])];
      const index = messages.findIndex(
        (existing) =>
          String(existing._id) === String(message._id) ||
          (message.clientMessageId &&
            existing.clientMessageId === message.clientMessageId)
      );

      if (index === -1) messages.push(message);
      else messages[index] = { ...messages[index], ...message };

      return { ...previous, messages };
    });
  }, []);

  /** Applies a partial patch to a set of messages by id. */
  const patchMessages = useCallback((chatId, messageIds, patch) => {
    setChatByIdlist((previous) => {
      if (!previous || String(previous._id) !== String(chatId)) return previous;

      const wanted = new Set((messageIds || []).map(String));

      return {
        ...previous,
        messages: (previous.messages || []).map((message) =>
          wanted.has(String(message._id))
            ? { ...message, ...(typeof patch === "function" ? patch(message) : patch) }
            : message
        ),
      };
    });
  }, []);

  /** Keeps the chat list preview and ordering fresh without a full refetch. */
  const applyChatListPreview = useCallback((payload) => {
    setChatlist((previous) =>
      (previous || []).map((chat) =>
        String(chat._id) === String(payload.chatId)
          ? { ...chat, lastMessage: payload.lastMessage }
          : chat
      )
    );
  }, []);

  const handleNewMessage = useCallback(
    (payload) => {
      upsertMessage(payload.message);
      applyChatListPreview(payload);
    },
    [upsertMessage, applyChatListPreview]
  );

  const handleMessageAck = useCallback(
    (payload) => {
      // Replace the optimistic bubble with the server's version of it.
      setChatByIdlist((previous) => {
        if (!previous || String(previous._id) !== String(payload.chatId)) {
          return previous;
        }

        const messages = (previous.messages || []).map((message) =>
          message.clientMessageId &&
          message.clientMessageId === payload.clientMessageId
            ? { ...payload.message }
            : message
        );

        return { ...previous, messages };
      });
    },
    []
  );

  const handleMessageMutated = useCallback(
    (payload) => {
      upsertMessage(payload.message);
      applyChatListPreview(payload);
    },
    [upsertMessage, applyChatListPreview]
  );

  const handleMessagesCleared = useCallback((payload) => {
    setChatByIdlist((previous) =>
      previous && String(previous._id) === String(payload.chatId)
        ? { ...previous, messages: [] }
        : previous
    );
  }, []);

  /** Single tick -> double tick -> blue tick, pushed by the server. */
  const handleStatusChange = useCallback(
    (payload) => {
      (payload.messages || []).forEach(({ messageId, status }) =>
        patchMessages(payload.chatId, [messageId], { status })
      );
    },
    [patchMessages]
  );

  /** A participant read (or received) our messages. */
  const handleSeen = useCallback(
    (payload) => {
      const stamp = payload.delivered
        ? { user: { _id: payload.userId }, deliveredAt: payload.deliveredAt }
        : { user: { _id: payload.userId }, seenAt: payload.seenAt };

      patchMessages(payload.chatId, payload.messageIds, (message) => {
        const key = payload.delivered ? "deliveredTo" : "seenBy";
        const list = message[key] || [];

        const already = list.some(
          (entry) => String(entry.user?._id || entry.user) === String(payload.userId)
        );

        return already ? {} : { [key]: [...list, stamp] };
      });
    },
    [patchMessages]
  );

  const handleChatListChanged = useCallback(
    (payload, reason) => {
      if (reason === "pinned" && payload?.chatId) {
        const isPin = payload.action === "pin";
        const chatIdStr = String(payload.chatId);
        setChatlist((prev) => {
          if (!prev) return prev;
          return prev.map((chat) => {
            if (String(chat._id) === chatIdStr) {
              let newPinnedBy = Array.isArray(chat.pinnedBy) ? [...chat.pinnedBy] : [];
              if (isPin) {
                if (
                  !newPinnedBy.some(
                    (p) => String(p.user?._id || p.user || "") === String(currentUserId)
                  )
                ) {
                  newPinnedBy.push({
                    user: currentUserId,
                    pinnedAt: Math.floor(Date.now() / 1000),
                  });
                }
              } else {
                newPinnedBy = newPinnedBy.filter(
                  (p) => String(p.user?._id || p.user || "") !== String(currentUserId)
                );
              }
              return {
                ...chat,
                isPinned: isPin,
                pinnedBy: newPinnedBy,
              };
            }
            return chat;
          });
        });

        setChatByIdlist((prev) => {
          if (!prev || String(prev._id) !== chatIdStr) return prev;
          let newPinnedBy = Array.isArray(prev.pinnedBy) ? [...prev.pinnedBy] : [];
          if (isPin) {
            if (
              !newPinnedBy.some(
                (p) => String(p.user?._id || p.user || "") === String(currentUserId)
              )
            ) {
              newPinnedBy.push({
                user: currentUserId,
                pinnedAt: Math.floor(Date.now() / 1000),
              });
            }
          } else {
            newPinnedBy = newPinnedBy.filter(
              (p) => String(p.user?._id || p.user || "") !== String(currentUserId)
            );
          }
          return {
            ...prev,
            isPinned: isPin,
            pinnedBy: newPinnedBy,
          };
        });
      }
      dispatch(GetUserChatAction());
    },
    [dispatch, currentUserId]
  );

  // "Delete for me" hides the conversation for the current user only, "leave"
  // takes them out of the group. Both close the open chat afterwards.
  const handleConfirmChatAction = async () => {
    const action = confirmAction;
    const id = ChatByIdlist?._id;
    if (!action || !id) return;

    try {
      const res =
        action === "leave"
          ? await LeaveChatService(id)
          : await DeleteChatForMeService(id);

      if (res.status === 200) {
        setConfirmAction(null);
        setChatId("");
        setChatByIdlist(null);
        dispatch(GetUserChatAction());
        dispatch(showSnackbar(res.data.message, "success"));
      }
    } catch (error) {
      dispatch(
        showSnackbar(
          error?.response?.data?.message || "Action could not be completed",
          "error"
        )
      );
    }
  };

  const handleRenameChat = async () => {
    const name = renameValue.trim();
    if (!name) {
      dispatch(showSnackbar("Chat name cannot be empty", "error"));
      return;
    }

    try {
      const res = await RenameGroupChatService(ChatByIdlist?._id, name);
      if (res.status === 200) {
        setRenameOpen(false);
        dispatch(GetUserChatAction());
        dispatch(GetUserChatByIdAction(ChatByIdlist?._id));
        dispatch(showSnackbar(res.data.message, "success"));
      }
    } catch (error) {
      dispatch(
        showSnackbar(
          error?.response?.data?.message || "Could not rename the chat",
          "error"
        )
      );
    }
  };

  const realtime = useChatSocket({
    activeChatId: chatId || null,
    onNewMessage: handleNewMessage,
    onMessageAck: handleMessageAck,
    onMessageMutated: handleMessageMutated,
    onMessagesCleared: handleMessagesCleared,
    onStatusChange: handleStatusChange,
    onSeen: handleSeen,
    onChatListChanged: handleChatListChanged,
  });

  // Follow the conversation as new messages land.
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [ChatByIdlist?.messages?.length]);

  /** The other side of a 1:1 chat, used for the presence line in the header. */
  const activeCounterpart = useMemo(() => {
    if (!ChatByIdlist || ChatByIdlist.isGroupChat) return null;
    return (ChatByIdlist.participants || []).find(
      (participant) => String(participant._id) !== String(currentUserId)
    );
  }, [ChatByIdlist, currentUserId]);

  const getChat = async (id) => {
    setChatId(id);
    setOpen(false);
    await postmarkSeenMessagesAPI(id)
      .then((res) => {
        if (res.status === 200) {
          toggleDrawer();
        }
        return null;
      })
      .catch((err) => {
        console.log(err);
      });
    dispatch(GetUserChatByIdAction(id));
  };
  const ChatByIdlistState = useSelector(
    (state) => state.setting?.chat?.data?.data
  );

  useEffect(() => {
    setChatByIdlist(ChatByIdlistState);
    ChatByIdlistState?.messages?.forEach((item) => {
      if (item.sender?._id === window.sessionStorage.getItem("user_id")) {
        const creationMoment = moment.unix(item.dateTime);
        const expirationTime = creationMoment.add(2, "minutes");
        const now = moment();
        const timeRemaining = expirationTime.diff(now, "milliseconds");

        if (timeRemaining > 0) {
          // Set timeout to hide the icons after 2 minutes (or less, depending on how much time has passed)
          setVisibleIcons((prev) => ({ ...prev, [item._id]: true }));
          setTimeout(() => {
            setVisibleIcons((prev) => ({ ...prev, [item._id]: false }));
          }, timeRemaining);
        }
      }
    });
  }, [ChatByIdlistState]);

  // //(ChatByIdlistState);

  const RolelistState = useSelector(
    (state) => state.setting?.role?.data?.roles
  );

  useEffect(() => {
    dispatch(GetRoleAction());
  }, []);

  useEffect(() => {
    setRolelist(RolelistState);
  }, [RolelistState]);

  const handleCloseGroupChatModal = () => setAddGroupChat(!AddGroupChat);

  // Seed the unread badges with a single request (previously one request per
  // chat). The websocket keeps them live from there on.
  useEffect(() => {
    if (!ChatlistState || ChatlistState.length === 0) {
      setChatlist(ChatlistState || []);
      return undefined;
    }

    // Immediately reflect ChatlistState so pinned chats & order show with 0ms delay
    setChatlist((prev) => {
      const prevMap = new Map((prev || []).map((c) => [String(c._id), c.count]));
      return ChatlistState.map((chat) => ({
        ...chat,
        count: prevMap.get(String(chat._id)) ?? (chat.unseenMessageCount || 0),
      }));
    });

    let cancelled = false;

    const seedUnreadCounts = async () => {
      try {
        const token = window.sessionStorage.getItem("user_token");
        const response = await axios.get(
          `${basicurl}/api/chat/unread-summary?_t=${Date.now()}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const byChat = response.data?.data?.byChat || {};

        if (!cancelled) {
          setChatlist((prev) =>
            (prev || ChatlistState).map((chat) => ({
              ...chat,
              count: byChat[String(chat._id)] ?? chat.count ?? 0,
            }))
          );
        }
      } catch (error) {
        console.error("Error fetching unread summary", error);
      }
    };

    seedUnreadCounts();

    return () => {
      cancelled = true;
    };
  }, [ChatlistState]);

  function generate(array, IconChat) {
    return array?.map((value) => {
      // Live badge while the socket is up, seeded value while it is not.
      const unreadCount = realtime.connected
        ? realtime.unreadFor(value._id)
        : value.count;

      const others = (value.participants || []).filter(
        (participant) => String(participant._id) !== String(currentUserId)
      );
      const counterpart = value.participants?.length === 2 ? others[0] : null;
      const someoneOnline = others.some((participant) =>
        realtime.isUserOnline(participant._id)
      );
      const typingHere = Object.keys(
        realtime.typingByChat[value._id] || {}
      ).length > 0;

      return (
        // A stable key per chat. Without one React reconciles these rows
        // by index, and this list reorders (pinned chats jump to the top)
        // while each row's icon slot swaps between three different
        // component types - so a row could keep the previous chat's icon
        // until the whole list was remounted by a page reload.
        <React.Fragment key={value._id}>
          <ListItem className="w-100 p-0">
            <ListItemButton
              onClick={() => {
                getChat(value._id);
              }}
              sx={{ px: 1, py: 1, borderRadius: "10px", gap: 0.5 }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                {" "}
                <Badge badgeContent={unreadCount} color="primary">
                  {isChatPinned(value) ? (
                    <PushPinSharpIcon htmlColor="#E8363D" />
                  ) : (value.participants || []).length > 2 ? (
                    <Group htmlColor="#6d597a" />
                  ) : (
                    <Chat htmlColor="#6d597a" />
                  )}
                </Badge>
              </ListItemIcon>
              <ListItemText disableTypography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    minWidth: 0,
                  }}
                >
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.75,
                        minWidth: 0,
                      }}
                    >
                      <OnlineDot
                        online={someoneOnline}
                        lastSeen={
                          counterpart ? realtime.lastSeenOf(counterpart._id) : null
                        }
                      />
                      <Typography
                        noWrap
                        title={value.chatName}
                        sx={{
                          minWidth: 0,
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#2F378D",
                        }}
                      >
                        {value.chatName}
                      </Typography>
                    </Box>

                    {counterpart?.organization?.organizationName && (
                      <Typography
                        noWrap
                        sx={{ fontSize: 11, color: "#98a2b3", mt: 0.1 }}
                      >
                        {counterpart.organization.organizationName}
                      </Typography>
                    )}

                    <Typography
                      noWrap
                      sx={{
                        fontSize: 12,
                        mt: 0.25,
                        fontStyle: typingHere ? "italic" : "normal",
                        color: typingHere ? "#2F378D" : "#667085",
                      }}
                    >
                      {typingHere
                        ? "typing…"
                        : value.lastMessage?.text
                          ? value.lastMessage.text
                          : value.participants.length > 2
                            ? `${value.participants.length} members`
                            : "No messages yet"}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", flexShrink: 0 }}>
                    <IconButton
                      size="small"
                      title="Chat options"
                      onClick={(e) => {
                        e.stopPropagation();
                        setListMenu({ anchor: e.currentTarget, chat: value });
                      }}
                      sx={{ color: "#adb5bd" }}
                    >
                      <MoreVertIcon sx={{ fontSize: 20 }} />
                    </IconButton>
                  </Box>
                </Box>
              </ListItemText>
            </ListItemButton>
          </ListItem>
          <Divider component="li" />
        </React.Fragment>
      );
    });
  }

  const UserlistState = useSelector(
    (state) => state.setting?.user?.data?.activeUsers
  );

  //("user list", UserlistState);

  useEffect(() => {
    setTable_load(true);
    dispatch(GetUserAction());
  }, []);

  useEffect(() => {
    const updatedData = UserlistState?.map(({ firstName, ...rest }) => ({
      title: firstName,
      ...rest,
    }));
    setUserlist(updatedData);
    setTable_load(false);
  }, [UserlistState]);

  const deleteOnetoOneMsg = async (msgId, personId) => {
    //("msg delete id=>", msgId, "deleting for person id=>", personId);
    await DeleteMsgFromChatService(personId, msgId)
      .then((res) => {
        if (res.status === 200) {
          // //(res);
          dispatch(GetUserChatByIdAction(personId));
          dispatch(showSnackbar(res.data.message, "success"));
        }
      })
      .catch((e) => {
        setFormLoading(false);
        dispatch(showSnackbar(apiErrorMessage(e), "error"));
      });
  };

  const isChatPinned = useCallback(
    (targetChat) =>
      isChatPinnedFor(targetChat, resolveMyId(currentUserId), Chatlist),
    [Chatlist, currentUserId]
  );

  const handleTogglePinChat = async (targetChatId, currentlyPinned) => {
    if (!targetChatId) return;
    const action = currentlyPinned ? "unpin" : "pin";
    const isPin = action === "pin";
    const chatIdStr = String(targetChatId);

    // Optimistically update Chatlist and ChatByIdlist immediately
    setChatlist((prev) => {
      if (!prev) return prev;
      return prev.map((chat) => {
        if (String(chat._id) === chatIdStr) {
          let newPinnedBy = Array.isArray(chat.pinnedBy) ? [...chat.pinnedBy] : [];
          if (isPin) {
            if (
              !newPinnedBy.some(
                (p) => String(p.user?._id || p.user || "") === String(currentUserId)
              )
            ) {
              newPinnedBy.push({
                user: currentUserId,
                pinnedAt: Math.floor(Date.now() / 1000),
              });
            }
          } else {
            newPinnedBy = newPinnedBy.filter(
              (p) => String(p.user?._id || p.user || "") !== String(currentUserId)
            );
          }
          return {
            ...chat,
            isPinned: isPin,
            pinnedBy: newPinnedBy,
          };
        }
        return chat;
      });
    });

    setChatByIdlist((prev) => {
      if (!prev || String(prev._id) !== chatIdStr) return prev;
      let newPinnedBy = Array.isArray(prev.pinnedBy) ? [...prev.pinnedBy] : [];
      if (isPin) {
        if (
          !newPinnedBy.some(
            (p) => String(p.user?._id || p.user || "") === String(currentUserId)
          )
        ) {
          newPinnedBy.push({
            user: currentUserId,
            pinnedAt: Math.floor(Date.now() / 1000),
          });
        }
      } else {
        newPinnedBy = newPinnedBy.filter(
          (p) => String(p.user?._id || p.user || "") !== String(currentUserId)
        );
      }
      return {
        ...prev,
        isPinned: isPin,
        pinnedBy: newPinnedBy,
      };
    });

    try {
      const res = await dispatch(MarkedChatAsPinned(targetChatId, action));
      await dispatch(GetUserChatAction());
      if (ChatByIdlist?._id === targetChatId) {
        dispatch(GetUserChatByIdAction(targetChatId));
      }
      dispatch(
        showSnackbar(
          res?.data?.message ||
            `Chat ${action === "pin" ? "pinned" : "unpinned"} successfully`,
          "success"
        )
      );
    } catch (error) {
      dispatch(GetUserChatAction());
      const msg =
        error?.response?.data?.message ||
        `Failed to ${action} chat`;
      dispatch(showSnackbar(msg, "error"));
    }
  };

  const pinnedChat = (id) => {
    const chat =
      Chatlist?.find((c) => String(c._id) === String(id)) ||
      (ChatByIdlist?._id === id ? ChatByIdlist : null);
    handleTogglePinChat(id, isChatPinned(chat));
  };

  const markAsUnread = async (id) => {
    if (!id) return;
    try {
      const res = await dispatch(MarkedChatAsUnread(id));
      await dispatch(GetUserChatAction());
      dispatch(
        showSnackbar(
          res?.data?.message || "Chat marked as unread",
          "success"
        )
      );
    } catch (error) {
      dispatch(
        showSnackbar(
          error?.response?.data?.message || "Failed to mark as unread",
          "error"
        )
      );
    }
  };

  const EditOnetoOneMsg = async (msgId, personId, text) => {
    let data = { text: ChatEditMsg };
    if (ChatEditMsg !== "") {
      await EditMsgToChatService(personId, msgId, data)
        .then((res) => {
          if (res.status === 200) {
            // //(res);
            dispatch(GetUserChatByIdAction(personId));
            dispatch(showSnackbar(res.data.message, "success"));
            setChatTextField([]);
            setChatEditMsg("");
          }
        })
        .catch((e) => {
          setFormLoading(false);
          dispatch(showSnackbar(apiErrorMessage(e), "error"));
        });
    } else {
      dispatch(showSnackbar("Message is required to edit!", "error"));
    }
  };
  // handle close of modal
  const handleClosePersonChat = () => setAddPersonChat(!AddPersonChat);
  const handleCloseRemovePersonChat = () =>
    setRemovePersonChat(!RemovePersonChat);

  const downloadFile = async (fileUrl) => {
    window.open(fileUrl, "_blank", "noopener noreferrer");
  };

  const FileHandler = (data) => {
    // console.log(data.url);
    return (
      data?.url?.length > 0 &&
      data.url.map((fileUrl, index) => {
        const fileExtension = fileUrl?.split(".").pop().toLowerCase();
        const urlParts = fileUrl?.split("/");
        const fullFileName = urlParts[urlParts.length - 1];
        // console.log(fileUrl, fileExtension, urlParts, fullFileName);

        if (fileExtension === "xlsx") {
          return (
            <div key={index} className="mt-2 d-flex align-items-center">
              <div className="filename-icon">
                <img
                  src="/assest/folderpng/excel.png"
                  alt="file icon"
                  className="w-100 h-100"
                />
              </div>
              <a
                href={fileUrl}
                download={fullFileName}
                style={{ textDecoration: "none", color: "blue" }}
              >
                <Typography
                  className="px-2"
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W400}
                  fontSize={fontSize.h4.medium}
                  color={ThemeColor.BLACK}
                  align="left"
                >
                  {fullFileName}
                </Typography>
              </a>
              <IconButton onClick={() => downloadFile(fileUrl)}>
                <DownloadIcon fill="red" sx={{ color: "red" }} />
              </IconButton>

            </div>
          );
        } else if (fileExtension === "docx" || fileExtension === "doc") {
          return (
            <div className="mt-2 d-flex align-items-center" key={index}>
              <div className="filename-icon">
                <img
                  src="/assest/folderpng/word.png"
                  alt="Word Icon"
                  className="w-100 h-100"
                />
              </div>
              <a
                href={fileUrl}
                download={fullFileName}
                style={{ textDecoration: "none", color: "blue" }}
              >
                <Typography
                  className="px-2"
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W400}
                  fontSize={fontSize.h4.medium}
                  color={ThemeColor.BLACK}
                  align="left"
                >
                  {fullFileName}
                </Typography>
              </a>
              <IconButton onClick={() => downloadFile(fileUrl)}>
                <DownloadIcon fill="red" sx={{ color: "red" }} />
              </IconButton>
            </div>
          );
        } else if (fileExtension === "pdf") {
          return (
            <div key={index} className="mt-2 d-flex align-items-center">
              <div className="filename-icon">
                <img
                  src="/assest/folderpng/pdf.png"
                  alt="file icon"
                  className="w-100 h-100"
                />
              </div>
              <a
                href={fileUrl}
                target="_blank"
                // download={fullFileName}
                style={{ textDecoration: "none", color: "blue" }}
              >
                <Typography
                  className="px-2"
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W400}
                  fontSize={fontSize.h4.medium}
                  color={ThemeColor.BLACK}
                  align="left"
                >
                  {fullFileName}
                </Typography>
              </a>
              <IconButton onClick={() => downloadFile(fileUrl)}>
                <DownloadIcon fill="red" sx={{ color: "red" }} />
              </IconButton>
            </div>
          );
        } else {
          return (
            <div key={index} className="mt-2 d-flex">
              <img
                // onClick={() => downloadFile(fileUrl)}
                src={fileUrl}
                style={{
                  width: "100px",
                  height: "100px",
                }}
                alt="chatimg"
              />
              <IconButton onClick={() => downloadFile(fileUrl)}>
                <DownloadIcon fill="red" sx={{ color: "red" }} />
              </IconButton>
            </div>
          );
        }
      })
    );
  };
  const FinalChatList = useMemo(
    () =>
      buildChatList({
        // The page's own copy is patched live by the socket, but it is seeded
        // from redux by an effect - so on the first paint after arriving from
        // another page it is still empty while redux already has the chats.
        local: Chatlist,
        fromStore: ChatlistState,
        filter: filterChat,
        myId: resolveMyId(currentUserId),
      }),
    [Chatlist, ChatlistState, filterChat, currentUserId]
  );

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "center" },
          justifyContent: "space-between",
          gap: { xs: 1.5, sm: 2 },
          mb: { xs: 2, md: 2.5 },
        }}
      >
        <Typography
          fontFamily={FontFamily.Poppins}
          fontWeight={fontWeight.W600}
          sx={{ fontSize: { xs: fontSize.h3.large, sm: fontSize.h2.small } }}
        >
          Messages
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: { xs: "space-between", sm: "flex-end" },
            gap: 1.5,
            flexShrink: 0,
          }}
        >
          <FormControl size="small" sx={{ minWidth: { xs: 120, sm: 140 } }}>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterChat}
              onChange={handleChange}
              sx={{ borderRadius: "10px" }}
            >
              <MenuItem value={"ALL"}>All</MenuItem>
              <MenuItem value={"GROUP"}>Group</MenuItem>
              <MenuItem value={"PERSONAL"}>Personal</MenuItem>
            </Select>
          </FormControl>

          <OutlineCustomButton
            variant="contained"
            type="submit"
            backgroundColor={ThemeColor.PURPLE}
            onClick={() => handleCloseGroupChatModal()}
          >
            <Msg stroke={"black"} /> &nbsp;Create Chat
          </OutlineCustomButton>
        </Box>
      </Box>

      <div className="chat-container">
        <div className="chat-shell">
          <ChatListNav
            toggleDrawer={toggleDrawer}
            Chatlist={FinalChatList}
            isOpen={isOpen}
            generate={generate}
          />

          <div className="chat-body">
            {/* Conversation header - avatar, name, presence, actions */}
            <div className="chat-header">
              <IconButton
                onClick={toggleDrawer}
                className="drawer-toggle-btn"
                size="small"
                aria-label="conversations"
              >
                {!isOpen ? <MenuIcon /> : <CloseIcon />}
              </IconButton>

              {ChatByIdlist ? (
                <>
                  <div className="chat-header-avatar">
                    {(ChatByIdlist?.chatName || "?").charAt(0).toUpperCase()}
                  </div>

                  <div className="chat-header-info">
                    <Typography noWrap className="chat-header-name">
                      {ChatByIdlist?.chatName}
                    </Typography>
                    <div className="chat-header-status">
                      {activeCounterpart ? (
                        <>
                          <OnlineDot
                            online={realtime.isUserOnline(activeCounterpart._id)}
                            lastSeen={realtime.lastSeenOf(activeCounterpart._id)}
                            size={8}
                          />
                          <PresenceLabel
                            online={realtime.isUserOnline(activeCounterpart._id)}
                            lastSeen={realtime.lastSeenOf(activeCounterpart._id)}
                          />
                        </>
                      ) : (
                        <Typography fontSize={11} color="#8a8d91">
                          {(ChatByIdlist.participants || []).length} members ·{" "}
                          {
                            (ChatByIdlist.participants || []).filter(
                              (participant) =>
                                realtime.isUserOnline(participant._id)
                            ).length
                          }{" "}
                          online
                        </Typography>
                      )}

                      {!realtime.connected && (
                        <Typography fontSize={11} color={ThemeColor.RED}>
                          • reconnecting…
                        </Typography>
                      )}
                    </div>
                  </div>

                  <div className="chat-header-actions">
                    {(ChatByIdlist?.participants || []).length > 2 && (
                      <Tooltip title="Rename chat">
                        <IconButton
                          size="small"
                          onClick={() => {
                            setRenameValue(ChatByIdlist?.chatName || "");
                            setRenameOpen(true);
                          }}
                        >
                          <DriveFileRenameOutlineIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}

                    {(() => {
                      const isPinned = isChatPinned(ChatByIdlist);
                      return (
                        <Tooltip title={isPinned ? "Unpin chat" : "Pin chat"}>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleTogglePinChat(ChatByIdlist?._id, isPinned);
                            }}
                          >
                            <PushPinSharpIcon
                              fontSize="small"
                              htmlColor={isPinned ? "#E8363D" : undefined}
                            />
                          </IconButton>
                        </Tooltip>
                      );
                    })()}

                    <Tooltip title="Mark as unread">
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          markAsUnread(ChatByIdlist?._id);
                        }}
                      >
                        <MarkAsUnread fontSize="small" />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="More">
                      <IconButton
                        size="small"
                        onClick={(e) => setChatMenuAnchor(e.currentTarget)}
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>

                    <Menu
                      anchorEl={chatMenuAnchor}
                      open={Boolean(chatMenuAnchor)}
                      onClose={() => setChatMenuAnchor(null)}
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      transformOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                      {(() => {
                        const isPinned = isChatPinned(ChatByIdlist);
                        return (
                          <MenuItem
                            onClick={() => {
                              setChatMenuAnchor(null);
                              handleTogglePinChat(ChatByIdlist?._id, isPinned);
                            }}
                          >
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <PushPinSharpIcon
                                fontSize="small"
                                htmlColor={isPinned ? "#E8363D" : "#667085"}
                              />
                            </ListItemIcon>
                            <ListItemText primaryTypographyProps={{ fontSize: 14 }}>
                              {isPinned ? "Unpin chat" : "Pin chat"}
                            </ListItemText>
                          </MenuItem>
                        );
                      })()}
                      {(ChatByIdlist?.participants || []).length > 2 && (
                        <MenuItem
                          onClick={() => {
                            setChatMenuAnchor(null);
                            setConfirmAction("leave");
                          }}
                        >
                          <ListItemIcon sx={{ minWidth: 32 }}>
                            <ExitToAppIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText primaryTypographyProps={{ fontSize: 14 }}>
                            Leave chat
                          </ListItemText>
                        </MenuItem>
                      )}

                      <MenuItem
                        onClick={() => {
                          setChatMenuAnchor(null);
                          setConfirmAction("delete");
                        }}
                        sx={{ color: ThemeColor.RED }}
                      >
                        <ListItemIcon sx={{ minWidth: 32 }}>
                          <DeleteOutline
                            fontSize="small"
                            sx={{ color: ThemeColor.RED }}
                          />
                        </ListItemIcon>
                        <ListItemText primaryTypographyProps={{ fontSize: 14 }}>
                          Delete chat for me
                        </ListItemText>
                      </MenuItem>
                    </Menu>
                  </div>
                </>
              ) : null}
            </div>

            {/* Main content */}
            <div className={`main-content`}>
            {ChatByIdlist ? (
              <Box sx={{ width: "100%" }}>
                  {ChatByIdlist?.messages?.map((data) => {
                    // Activity notices ("X added Y", "X left") are not anybody's
                    // message: centred pill with the date and time, no bubble,
                    // no ticks, no hover actions.
                    if (data.messageType === "system") {
                      return (
                        <div className="chat-row-system" key={data._id}>
                          <span className="chat-system-pill">
                            {data.text}
                            <span className="chat-system-time">
                              {moment
                                .unix(data.dateTime)
                                .format("D MMM YYYY, h:mm A")}
                            </span>
                          </span>
                        </div>
                      );
                    }

                    return (
                      <>
                        {String(data.sender?._id || data.sender) ===
                          String(currentUserId) ? (
                          <div className="chat-row chat-row-out">
                            <div className="chat-bubble chat-bubble-out">
                              {chatTextField.some((id) => id === data._id) ? (
                                <div className="d-flex align-items-center">
                                  <OutlinedInputField
                                    value={ChatEditMsg}
                                    fullWidth={true}
                                    onChange={(e) =>
                                      setChatEditMsg(e.target.value)
                                    }
                                  />
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      EditOnetoOneMsg(
                                        data?._id,
                                        ChatByIdlist?._id
                                      );
                                    }}
                                  >
                                    <CheckIcon htmlColor={ThemeColor.BLUE} />
                                  </IconButton>

                                  <IconButton
                                    size="small"
                                    onClick={() => setChatTextField([])}
                                  >
                                    <CloseIcon htmlColor={ThemeColor.RED} />
                                  </IconButton>
                                </div>
                              ) : (
                                <>
                                  {data && FileHandler(data)}
                                  {data.text ? (
                                    <Typography className="chat-bubble-text">
                                      <Linkify
                                        componentDecorator={(decoratedHref, decoratedText, key) => (
                                          <a
                                            rel="noopener noreferrer"
                                            href={decoratedHref.toLocaleLowerCase().replace("https://applycae.com", "")}
                                            key={key}
                                            style={{ color: '#0b57d0', textDecoration: 'underline' }}
                                          >
                                            {decoratedText}
                                          </a>
                                        )}
                                      >
                                        {data.text}
                                      </Linkify>
                                    </Typography>
                                  ) : null}

                                  <span className="chat-bubble-meta">
                                    {moment.unix(data.dateTime).format("h:mm A")}
                                    {data.isEdit === true &&
                                      data.isDeleted === false
                                      ? " · edited"
                                      : ""}
                                    {/* single / double / blue ticks */}
                                    {data.isDeleted === false && (
                                      <MessageTicks
                                        status={
                                          data.status || MESSAGE_STATUS.SENT
                                        }
                                      />
                                    )}
                                  </span>
                                </>
                              )}
                            </div>
                            <div className="chat-row-actions">
                              {visibleIcons[data._id] && (
                                <div className="d-flex justify-content-end">
                                  {data.isDeleted === false && (
                                    <IconButton
                                      onClick={() =>
                                        deleteOnetoOneMsg(
                                          data._id,
                                          ChatByIdlist._id
                                        )
                                      }
                                    >
                                      <DeleteForeverRounded
                                        htmlColor={ThemeColor.RED}
                                      />
                                    </IconButton>
                                  )}

                                  {data.isDeleted === false && (
                                    <IconButton
                                      onClick={() => {
                                        setChatEditMsg(data.text);
                                        let array = [];
                                        array.push(data._id);
                                        setChatTextField(array);
                                      }}
                                    >
                                      <EditIcon
                                        htmlColor={ThemeColor.BLUE}
                                      />
                                    </IconButton>
                                  )}
                                </div>
                              )}
                              {/* <Tooltip title="Seen by">
                                    <IconButton
                                      size="small"
                                      onClick={handleClick}
                                      sx={{
                                        position: "absolute",
                                        bottom: 4,
                                        right: 4,
                                      }}
                                    >
                                      <EyeFilled style={{color:"black"}}/>
                                    </IconButton> */}
                              {data.seenBy?.length > 0 && (
                                <div>
                                  {/* <Tooltip title="Seen by"> */}
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      setSelectedMsgId(data._id);
                                      setAnchorEl(e.currentTarget);
                                    }}
                                  // sx={{
                                  //   position: "absolute",
                                  //   bottom: 4,
                                  //   right: 4,
                                  // }}
                                  >
                                    <EyeFilled style={{ color: "black" }} />
                                  </IconButton>
                                  {/* </Tooltip> */}

                                  <Menu
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                      // vertical: "top",
                                      horizontal: "left",
                                    }}
                                  // transformOrigin={{
                                  //   vertical: "bottom",
                                  //   horizontal: "right",
                                  // }}
                                  >
                                    {data._id === selectedMsgId &&
                                      data.seenBy?.map((data, index) => (
                                        <MenuItem key={index}>
                                          {data.user?._id !==
                                            window.sessionStorage.getItem(
                                              "user_id"
                                            ) ? (
                                            <div>
                                              <Typography
                                                fontWeight={fontWeight.W700}
                                              >
                                                {data.user.firstName}{" "}
                                                {data.user.lastName}
                                              </Typography>
                                              <Typography
                                                className="px-2"
                                                fontSize={fontSize.h4.medium}
                                                fontWeight={fontWeight.W400}
                                              >
                                                {moment
                                                  .unix(data.seenAt)
                                                  .format("llll")}
                                              </Typography>
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </MenuItem>
                                      ))}
                                  </Menu>
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          ReceiverSection(data)
                        )}
                      </>
                    );
                  })}

                  {/* live "… is typing" bubble */}
                  <TypingIndicator users={realtime.typingUsers} />

                  {/* scroll anchor so new messages stay in view */}
                  <div ref={messagesEndRef} />
              </Box>
            ) : (
              <Box className="chat-empty">
                <Typography
                  fontSize={fontSize.h3.large}
                  fontFamily={FontFamily.Poppins}
                  color={ThemeColor.GREY}
                >
                  Click User To chat
                </Typography>
              </Box>
            )}
            </div>

            {/* Composer */}
            {ChatByIdlist && (
              <div className="chat-composer">
                <Formik
                  initialValues={{
                    text: "",
                    url: [],
                  }}
                  onSubmit={async (values, { resetForm }) => {
                    const text = values.text || "";
                    const urls = (values.url || [])
                      .map((file) => (typeof file === "string" ? file : file?.url))
                      .filter(Boolean);

                    if (!text.trim() && urls.length === 0) return;

                    setFormLoading(true);

                    // One message carries the text and every attachment, so the
                    // recipient sees a single bubble instead of one per file.
                    const clientMessageId = `tmp-${Date.now()}-${Math.random()
                      .toString(16)
                      .slice(2)}`;

                    const me = (ChatByIdlist?.participants || []).find(
                      (participant) =>
                        String(participant._id) === String(currentUserId)
                    );

                    // Optimistic bubble: shows instantly with a clock icon and
                    // is reconciled by clientMessageId when the server acks.
                    upsertMessage({
                      _id: clientMessageId,
                      chatId,
                      clientMessageId,
                      sender: me || { _id: currentUserId },
                      text,
                      url: urls,
                      attachments: urls.map((url) => ({ url })),
                      dateTime: moment().unix(),
                      isEdit: false,
                      isDeleted: false,
                      seenBy: [],
                      deliveredTo: [],
                      status: MESSAGE_STATUS.SENDING,
                    });

                    realtime.stopTyping(chatId);

                    const payload = {
                      chatId,
                      text,
                      url: urls,
                      clientMessageId,
                    };

                    try {
                      await realtime.sendMessage(payload);
                    } catch (socketError) {
                      // Socket unavailable -> fall back to the REST endpoint,
                      // which fans out the very same realtime events.
                      try {
                        await AddtochatService(payload);
                        dispatch(GetUserChatByIdAction(chatId));
                      } catch (httpError) {
                        patchMessages(chatId, [clientMessageId], {
                          status: MESSAGE_STATUS.FAILED,
                        });
                        dispatch(
                          showSnackbar(
                            httpError?.response?.data?.message ||
                            "Message could not be sent",
                            "error"
                          )
                        );
                      }
                    }

                    setFormLoading(false);
                    setAttachedFiles([]);
                    childRef.current?.resetDropzone();
                    resetForm();
                  }}
                // validationSchema={validationSchema}
                >
                  {({
                    values,
                    errors,
                    handleBlur,
                    handleChange,
                    touched,
                    handleSubmit,
                    setFieldValue,
                  }) => (
                    <Form className="w-100">
                      {/* files picked but not sent yet */}
                      {AttachedFiles?.length > 0 && (
                        <div className="chat-attachments">
                          {AttachedFiles.map((data, index) => (
                            <div className="chat-attachment-chip" key={index}>
                              <Typography
                                noWrap
                                sx={{ fontSize: 12, color: ThemeColor.PURPLE }}
                              >
                                {data?.name}
                              </Typography>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  const updated = AttachedFiles.filter(
                                    (_, idx) => idx !== index
                                  );
                                  setAttachedFiles(updated);
                                  const updatedUrls = updated.map(
                                    (file) => file.uploadedUrl
                                  );
                                  setFieldValue("url", updatedUrls);
                                }}
                              >
                                <DeleteOutline sx={{ fontSize: 16 }} />
                              </IconButton>
                            </div>
                          ))}
                        </div>
                      )}

                      <div className="chat-composer-row">
                        <div className="chat-composer-attach">
                          <AttachmentDropzone
                            ref={childRef}
                            handleMydropzoneFile={(updatedFiles, files) => {
                              setAttachedFiles(files);
                              setFieldValue("url", updatedFiles);
                            }}
                          />
                        </div>

                        <div className="chat-composer-input">
                          <OutlinedTextAreaField
                            multiline={true}
                            minRows={1}
                            maxRows={5}
                            value={values.text}
                            name={`text`}
                            onChange={(event) => {
                              handleChange(event);
                              // Broadcast "… is typing" to the other side
                              realtime.notifyTyping(chatId);
                            }}
                            onKeyDown={(event) => {
                              // Enter sends, Shift+Enter adds a new line
                              if (event.key === "Enter" && !event.shiftKey) {
                                event.preventDefault();
                                handleSubmit();
                              }
                            }}
                            onBlur={() => realtime.stopTyping(chatId)}
                            placeholder="Type a message"
                            fullWidth={true}
                          />
                        </div>

                        <IconButton
                          type="submit"
                          className="chat-send-btn"
                          disabled={
                            formLoading ||
                            (!values.text?.trim() && !values.url?.length)
                          }
                        >
                          {formLoading ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : (
                            <SendIcon fontSize="small" />
                          )}
                        </IconButton>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Rename a group chat */}
      <Dialog
        open={renameOpen}
        onClose={() => setRenameOpen(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle sx={{ fontSize: 18, fontWeight: 600 }}>
          Rename chat
        </DialogTitle>
        <DialogContent>
          <OutlinedInputField
            value={renameValue}
            name="renameValue"
            onChange={(e) => setRenameValue(e.target.value)}
            placeholder="Enter a chat name..."
            fullWidth={true}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <MuiButton
            variant="outlined"
            onClick={() => setRenameOpen(false)}
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              color: "#667085",
              borderColor: "#d0d5dd",
            }}
          >
            Cancel
          </MuiButton>
          <CustomButton
            variant="contained"
            backgroundColor={ThemeColor.PURPLE}
            color={ThemeColor.WHITE}
            onClick={handleRenameChat}
          >
            Save
          </CustomButton>
        </DialogActions>
      </Dialog>

      {/* Leave / delete confirmation */}
      <Dialog
        open={Boolean(confirmAction)}
        onClose={() => setConfirmAction(null)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle sx={{ fontSize: 18, fontWeight: 600 }}>
          {confirmAction === "leave" ? "Leave this chat?" : "Delete this chat?"}
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ fontSize: 14, color: "#667085" }}>
            {confirmAction === "leave"
              ? "You will be removed from this chat and stop receiving its messages. The other members keep the conversation."
              : "This chat will be removed for you only. Other members still see the conversation, and it comes back if someone sends a new message."}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <MuiButton
            variant="outlined"
            onClick={() => setConfirmAction(null)}
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              color: "#667085",
              borderColor: "#d0d5dd",
            }}
          >
            Cancel
          </MuiButton>
          <CustomButton
            variant="contained"
            backgroundColor={ThemeColor.RED}
            color={ThemeColor.WHITE}
            onClick={handleConfirmChatAction}
          >
            {confirmAction === "leave" ? "Leave" : "Delete"}
          </CustomButton>
        </DialogActions>
      </Dialog>

      <CreateGroupChatModal
        Organizationlist={Organizationlist}
        filteredUser={filteredUser}
        AddGroupChat={AddGroupChat}
        Rolelist={Rolelist}
        handleClose={handleCloseGroupChatModal}
      />

      <AddPersonToChatChatModal
        Participantlist={Chatlist?.filter(
          (data) => data._id === chatId
        )[0]?.participants?.map(({ firstName, ...rest }) => ({
          title: firstName,
          ...rest,
        }))}
        chatId={chatId}
        AddPersonChat={AddPersonChat}
        handleClose={handleClosePersonChat}
      />

      {/* Row actions for the conversation list, opened from the ⋮ button. */}
      <Menu
        anchorEl={listMenu.anchor}
        open={Boolean(listMenu.anchor)}
        onClose={() => setListMenu({ anchor: null, chat: null })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {listMenu.chat && (() => {
          const isPinned = isChatPinned(listMenu.chat);
          return (
            <MenuItem
              onClick={() => {
                const chat = listMenu.chat;
                setListMenu({ anchor: null, chat: null });
                handleTogglePinChat(chat?._id, isPinned);
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <PushPinSharpIcon
                  fontSize="small"
                  htmlColor={isPinned ? "#E8363D" : "#667085"}
                />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ fontSize: 14 }}>
                {isPinned ? "Unpin chat" : "Pin chat"}
              </ListItemText>
            </MenuItem>
          );
        })()}

        <MenuItem
          onClick={() => {
            const chat = listMenu.chat;
            setListMenu({ anchor: null, chat: null });
            handleClosePersonChat();
            setChatId(chat?._id);
          }}
        >
          <ListItemIcon sx={{ minWidth: 32 }}>
            <AddCircleTwoTone fontSize="small" htmlColor="#667085" />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: 14 }}>
            Add people
          </ListItemText>
        </MenuItem>

        {listMenu.chat &&
          listMenu.chat.participants?.length > 2 &&
          canRemoveParticipants(listMenu.chat) && (
            <MenuItem
              onClick={() => {
                const chat = listMenu.chat;
                setListMenu({ anchor: null, chat: null });
                handleCloseRemovePersonChat();
                setChatId(chat?._id);
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <RemoveCircleOutline fontSize="small" htmlColor="#667085" />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ fontSize: 14 }}>
                Manage members
              </ListItemText>
            </MenuItem>
          )}
      </Menu>

      {/* The dialog decides who may be removed, so it also receives the chat's
          creator - the same rule the server enforces. */}
      <RemovePersonToChatChatModal
        Participantlist={
          Chatlist?.find((data) => data._id === chatId)?.participants || []
        }
        createdBy={Chatlist?.find((data) => data._id === chatId)?.createdBy}
        chatId={chatId}
        RemovePersonChat={RemovePersonChat}
        handleClose={handleCloseRemovePersonChat}
      />
    </>
  );
};

function Chatlist() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<ChatlistPage />} />
    </div>
  );
}

export default Chatlist;
